// import { computeHeadingLevel } from '@testing-library/react';
import React, {Component, Fragment} from "react";
// import * as ReactBootStrap from "react-bootstrap";
import {Bar, Line} from "react-chartjs-2";
import "./chart.css";
let labelsArr = [];
let valuesArr = [];
let itemsColors = [];
let title = "";
class Chart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartInfo: {},
    };
    title = this.props.module.title;
    this.getChartsData();
  }
  // Handling the Chart data which sent in props
  getChartsData = () => {
    labelsArr = [];
    valuesArr = [];
    itemsColors = [];
    for (let i = 0; i < this.props.module.data.length; i++) {
      let label = this.props.module.data[i].label;
      let value = this.props.module.data[i].value;
      let color = this.props.module.color;
      labelsArr.push(label);
      valuesArr.push(value);
      itemsColors.push(color);
    }
  };
  // The "getDerivedStateFromProps" method is called right before rendering the element(s) in the DOM
  // And update the data eveytime the component rendered
  static getDerivedStateFromProps(props, state) {
    return {
      chartInfo: {
        labels: labelsArr,
        datasets: [
          {
            label: title,
            data: valuesArr,
            borderWidth: 1,
            backgroundColor: itemsColors,
            hoverBackgroundColor: itemsColors,
            fill: false,
          },
        ],
      },
    };
  }
  render() {
    console.log(this.state);
    let chartType = this.props.module.type;
    return (
      <Fragment>
        <h2 className="text-center mt-4 mb-4">{this.props.module.title}</h2>
        {chartType.includes("bar") ? (
          <div className="chart" id={this.props.module.id} key={Math.random()}>
            <Bar
              data={this.state.chartInfo}
              options={{
                maintainAspectRatio: false,
              }}
            />
          </div>
        ) : (
          ""
        )}
        {chartType.includes("line") ? (
          <div className="chart" id={this.props.module.id} key={Math.random()}>
            <Line
              data={this.state.chartInfo}
              options={{
                maintainAspectRatio: false,
                elements: {
                  line: {
                    tension: 0,
                  },
                },
              }}
            />
          </div>
        ) : (
          ""
        )}
      </Fragment>
    );
  }
}

export default Chart;
